import { getData, postData, putData } from "./rest-api-helper"

export async function getAllCust() {
    const details = {
        urlPath: "/customer"
    }

    const res = await getData(details);
    // console.log(res, "---------------getAllCust");
    return res;
}

export async function putCustStatus(custId, status) {
    const details = {
        urlPath: "/customer",
        queryParams: { custId: custId, status }
    }

    const res = await putData(details);
    // console.log(res + "---------------putCustStatus");
    return res;
}

export async function postCust(data) {
    const details = {
        urlPath: "/customer/create",
        body: {
            ...data
        }
    }

    const res = await postData(details);
    // console.log(res, "---------------postCust");
    return res;
}

export async function getSingleCust(custId) {
    const details = {
        urlPath: `/customer/getSingle/${custId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getSingleCust");
    return res;
}

export async function putCust(custId, data) {
    const details = {
        urlPath: `/customer/edit/${custId}`,
        body: {
            fName: data.fName,
            lName: data.lName,
            mobile2: data.mobile2,
            email: data.email,
            comName: data.comName,
            comAddress: data.comAddress,
            comContact_no: data.comContact_no,
            comDescription: data.comDescription,
            ...(data.gst_file?.length && { gst_file: data.gst_file }),
            ...(data.pan_file?.length && { pan_file: data.pan_file })
        }

    }

    const res = await putData(details);
    // console.log(res + "---------------putCust");
    return res;
}

export async function getAllCustWPgSch({ limit, pageNumber, searchKeyWord, fromDate, toDate, custRole }) {
    const details = {
        urlPath: "/customer",
        queryParams: {
            limit,
            offset: (pageNumber * limit) - limit,
            ...(searchKeyWord && { searchKeyWord }),
            ...(custRole && { custRole })
        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/customer",
        queryParams: {
            limit: 10000, // Fetch all for client-side filtering
            offset: 0,
            ...(searchKeyWord && { searchKeyWord }),
            ...(custRole && { custRole })
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllCustWPgSch");

    let finalData = res ? res : [];
    let finalCount = res2?.length;

    if (fromDate && toDate && res2 && res2.length > 0) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);

        const filtered = res2.filter(item => {
            const dateStr = item.custRegDate;
            if (!dateStr) return true;
            const itemDate = new Date(dateStr);
            return itemDate >= from && itemDate <= to;
        });

        finalCount = filtered.length;

        // Paginate locally
        const start = (pageNumber - 1) * limit;
        const end = start + limit;
        finalData = filtered.slice(start, end);
    }

    return {
        totalLength: finalCount,
        data: finalData
    }
}

export async function getAllMatTypes() {
    const details = {
        urlPath: "/customer/matTypes"
    }
    let res = await getData(details);

    // for (let i = 0; i < res.length; i++) {
    //     const e = res[i];
    //     e.label = e.label + " - " + capFirstLetter(e.category);
    //     // res.push({ ...e, label: e.label + capFirstLetter(e.category) })
    // }

    // console.log(res, "---------------getAllMatTypes");

    return res ? res : []
}

export async function getAllTrkTypes() {
    const details = {
        urlPath: "/customer/trkTypes"
    }
    let res = await getData(details);

    // console.log(res, "---------------getAllTrkTypes");

    return res ? res : []
}

// Toggles a favourite material type for the logged-in user (identified by JWT).
export async function postToggleMatTypeFav(material) {
    const details = {
        urlPath: "/customer/matTypeFavs/toggle",
        body: { material }
    }
    const res = await postData(details);
    return res;
}

export async function getAllMatTypesByCat(category) {
    if (category) {
        const details = {
            urlPath: "/customer/matTypesByCat/" + category
        }
        let res = await getData(details);

        // console.log(res, "---------------getAllMatTypesByCat");

        return res ? res : []
    } else {
        return []
    }
}

export async function putCustBankDetails(custId, data) {
    const details = {
        urlPath: `/customer/bankDetails/${custId}`,
        body: {
            accName: data.accName, accNo: data.accNo, ifsc: data.ifsc, bankName: data.bankName, branch: data.branch
        }

    }

    const res = await putData(details);
    // console.log(res + "---------------putCustBankDetails");
    return res;
}

export async function putCustBoRating({ custId, boCustRating, boCustFeedback }) {
    const details = {
        urlPath: `/customer/custRatingByBo/${custId}`,
        body: {
            boCustRating, boCustFeedback
        }

    }

    const res = await putData(details);
    // console.log(res + "---------------putCustBoRating");
    return res;
}

export async function getRateDetails() {
    const details = {
        urlPath: "/pricing/rateDetails"
    }
    let res = await getData(details);

    // console.log(res, "---------------getRateDetails");

    return res
}

export async function getZoneStates({ zoneId }) {
    if (zoneId) {
        const details = {
            urlPath: "/pricing/listOfStateByZone?zoneId=" + zoneId
        }
        let res = await getData(details);

        // console.log(res, "---------------getZoneStates");

        return res ? res : []
    } else {
        const details = {
            urlPath: "/pricing/listOfStateByZone"
        }
        let res = await getData(details);

        // console.log(res, "---------------getZoneStates");

        return res ? res : []
    }
}

export async function updateBaseRate(data) {
    // console.log(data)
    const details = {
        urlPath: "/pricing/baseRate",
        body: {
            ...data
        }
    }

    const res = await putData(details);
    // console.log(res, "---------------updateBaseRate");
    return res;
}

export async function putZoneAddress({ zoneId, address }) {
    const details = {
        urlPath: "/pricing/zoneAddress",
        body: {
            zoneId,
            address
        }
    }

    const res = await putData(details);
    return res;
}

export async function addZoneState({ dataArr, zoneId }) {
    // console.log({ dataArr, zoneId })
    const details = {
        urlPath: "/pricing/addStateInZone?zoneId=" + zoneId,
        body: dataArr
    }

    const res = await putData(details);
    // console.log(res, "---------------addZoneState");
    return res;
}

export async function rmvZoneState({ stateId }) {
    // console.log({ stateId })
    const details = {
        urlPath: "/pricing/rmvStateInZone",
        body: {
            stateId
        }
    }

    const res = await putData(details);
    // console.log(res, "---------------rmvZoneState");
    return res;
}

export async function getAllDelCustWPgSch({ limit, pageNumber, searchKeyWord }) {
    const details = {
        urlPath: "/customer/getAllDelCustomer",
        queryParams: {
            limit,
            offset: (pageNumber * limit) - limit,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/customer/getAllDelCustomer",
        queryParams: {
            // limit: 100000000000000,
            // offset: 0,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllDelCustWPgSch");

    return {
        totalLength: res2?.length,
        data: res ? res : []
    }
}